import { formSchema, formUischema, pageSchema, pageUischema, widgetSchema, widgetUischema } from './Schema'
import { getResetJsonForm } from "./Data"

export const getLocalForm = (formCode, perspectiveRoute, resetContext) => {
  let resetData = getResetJsonForm(formCode, perspectiveRoute)
  let current = {
    ui: formUischema,
    schema: formSchema,
    readOnly: false,
  }
  resetData = {
    ...resetData,
    current: current,
  }
  resetContext(resetData)
}

export const getLocalPage = (pageCode, perspectiveRoute, resetContext) => {
  let resetData = getResetJsonForm(pageCode, perspectiveRoute)
  let current = {
    ui: pageUischema,
    schema: pageSchema,
    readOnly: false,
  }
  resetData = {
    ...resetData,
    current: current,
  }
  resetContext(resetData)
}

export const getLocalWidget = (widgetCode, perspectiveRoute, resetContext) => {
  let resetData = getResetJsonForm(widgetCode, perspectiveRoute)
  let current = {
    ui: widgetUischema,
    schema: widgetSchema,
    readOnly: false,
  }
  resetData = {
    ...resetData,
    current: current,
  }
  resetContext(resetData)
}


export const getLocalDashboard = (dashboardCode, perspectiveRoute, resetContext) => {
  let resetData = getResetJsonForm(dashboardCode, perspectiveRoute)
  let current = {
    ui: widgetUischema,
    schema: widgetSchema,
    readOnly: false,
  }
  resetData = {
    ...resetData,
    current: current,
  }
  resetContext(resetData)
}